// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import languages from './config/languages';

// Importar traducciones directamente
import deTranslations from './locales/de/translation.json';
import enTranslations from './locales/en/translation.json';
import enAuTranslations from './locales/en-au/translation.json';
import esTranslations from './locales/es/translation.json';
import esCoTranslations from './locales/es-CO/translation.json';
import frTranslations from './locales/fr/translation.json';
import itTranslations from './locales/it/translation.json';
import ptTranslations from './locales/pt/translation.json';

const resources = {
  de: {
    translation: deTranslations
  },
  en: {
    translation: enTranslations
  },
  'en-au': {
    translation: enAuTranslations
  },
  es: {
    translation: esTranslations
  },
  'es-CO': {
    translation: esCoTranslations
  },
  fr: {
    translation: frTranslations
  },
  it: {
    translation: itTranslations
  },
  pt: {
    translation: ptTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    supportedLngs: Object.keys(languages),
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'cookie', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['cookie'],
    },
  });

export default i18n;
